import React, { useEffect, useState } from "react";
import PageHeader from "../../components/Header/PageHeader";
import PageWrapper from "../../components/Page/PageWrapper";
import { ArrowBack, ArrowForward, OpenInNew } from "@material-ui/icons";
import ProjectExpander from "../Project/ProjectExpander";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    getCart,
    getCartId,
    getCurrentProject,
    getLoading,
} from "../../reducers/project/selectors";
import { IProject } from "../../reducers/project";
import Scrollbars from "react-custom-scrollbars";
import { useFetch } from "../../hooks/useFetch";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { isEqual } from "lodash/fp";
import useThrottledEffect from "use-throttled-effect";
import content from "../../content";
import useDesktop from "../../components/Responsive/useDesktop";
import Mobile from "../../components/Responsive/Mobile";
import { AttributeHeader } from "../../components/Attributes/AttributesExpansion";
import Visualizer from "../Visualizer/Visualizer";
import { projectLabel } from "../Project/ProjectExpander";
import { Stepper } from "../Project/Stepper";
import { Price, Button } from "./Creator";

const Label = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;

  letter-spacing: -0.01em;

  color: #1e2029;
  display: flex;
  top: -30px;
  z-index: 30000;
  justify-content: center;
  position: relative;
  user-select: none;
`;

const Header = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 10px;
  letter-spacing: -0.01em;

  color: #1e2029;
`;

function ProjectsCart({}: IProjectsCart) {
    const cart: IProject[] = useSelector(getCart);
    const cartId = useSelector(getCartId);
    const [preview, setPreview] = useState(0);

    const desktop = useDesktop();

    const loading = useSelector(getLoading);

    const selectPreview = (i) => () => {
        setPreview(i);
    };

    useEffect(() => {
        const nextPreview = () => {
            setPreview(cart[preview + 1] ? preview + 1 : 0);
        };

        const interval = setInterval(() => {
            nextPreview();
        }, 5000);
        return () => clearInterval(interval);
    }, [preview]);

    const [responseNew, requestNew] = useFetch<{
        id: string;
        projects: IProject[];
    }>("/cart/");

    const [responseUpdate, requestUpdate] = useFetch<{
        id: string;
        projects: IProject[];
    }>("/cart/", {} as any, {
        method: "PUT",
    });

    const dispatch = useDispatch();

    const reset = () => dispatch({ type: ProjectActions.Reset });

    useThrottledEffect(
        () => {
            if (cartId && cart && !isEqual(cart, responseUpdate?.projects as any)) {
                requestUpdate(
                    {
                        projects: cart,
                    },
                    cartId
                ).then((project) => {
                    dispatch({
                        type: ProjectActions.UpdateCart,
                        cart: project,
                    });
                });
            } else {
                if (cart && !isEqual(cart, responseNew?.projects as any) && !cartId) {
                    requestNew({
                        projects: cart,
                    }).then((project) => {
                        dispatch({
                            type: ProjectActions.UpdateCart,
                            cart: project,
                        });
                    });
                }
            }
        },
        1000,
        [cart, cartId, responseNew, responseUpdate]
    );

    return (
        <>
            {/*<PageHeader*/}
            {/*  color={"#F9F9F9"}*/}
            {/*  height={"auto"}*/}
            {/*  header={content.getValue("header_cart")}*/}
            {/*/>*/}
            <PageWrapper
                padding={desktop ? "20px 20px" : "16px 16px"}
                menu={
                    <>
                        <AttributeHeader
                            style={{
                                width: "200px",
                                margin: "0 auto",
                                marginBottom: "15px",
                                paddingTop: "50px",
                                justifyContent: "center",
                            }}
                        >
                            {content.getValue("selected_doors")}
                        </AttributeHeader>
                        <Visualizer
                            offsetHeight={285}
                            small={true}
                            preview={cart[preview]?.components || []}
                        />
                        <Label>{projectLabel(cart[preview])}</Label>
                        <Stepper
                            step={preview}
                            steps={cart.length}
                            onClick={selectPreview}
                        />
                        <Price
                            anyPrice={
                                cart.length === 0
                                    ? 0
                                    : cart
                                        .reduce(
                                            (a, b: any) =>
                                                a.concat(
                                                    b.components.map((c: any) => ({
                                                        ...c,
                                                        price: Number(c.price) * b.count,
                                                    }))
                                                ),
                                            []
                                        )
                                        .reduce(
                                            (a, b: any) => (Number(a) + Number(b.price)).toFixed(2),
                                            ""
                                        )
                            }
                        />
                        <Link
                            style={{ pointerEvents: cart.length === 0 ? "none" : "unset" }}
                            to={"/order"}
                        >
                            <Button
                                disabled={cart.length === 0}
                                label={content.getValue("go_next")}
                            ></Button>
                        </Link>
                    </>
                }
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: `auto`,
                        maxHeight: `calc(100vh - ${desktop ? 162 : 195}px)`,
                        padding: desktop ? "20px" : "24px",
                        boxSizing: "border-box",
                        backgroundColor: "white",
                    }}
                >
                    <Header>{content.getValue("header_cart")}</Header>
                    <Scrollbars
                        autoHeight={true}
                        autoHeightMin={0}
                        autoHeightMax={"calc(100vh - 360px)"}
                    >
                        {cart.map((c) => (
                            <ProjectExpander key={c.id} project={c} />
                        ))}
                    </Scrollbars>
                    <Link to={"/"} onClick={reset}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                height: "70px",
                                marginTop: "10px",
                                marginBottom: "25px",
                                border: "2px dashed #1B576A",
                                boxSizing: "border-box",
                                cursor: "pointer",
                                background: "rgba(27, 87, 106, 0.05)",
                            }}
                        >
                            <img
                                src={"/static/icon/ic20-plus-circle.svg"}
                                style={{ marginRight: "5px" }}
                            />

                            {content.getValue("button_new_project")}
                        </div>
                    </Link>
                </div>
                <Mobile>
                    <Link
                        style={{ pointerEvents: cart.length === 0 ? "none" : "unset" }}
                        to={"/order"}
                    >
                        <Button
                            Icon={
                                <svg
                                    style={{
                                        position: "absolute",
                                        right: "20px",
                                    }}
                                    width="17"
                                    height="8"
                                    viewBox="0 0 17 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                                        fill={cart.length === 0 ? "rgba(0, 0, 0, 0.26)" : "#C41230"}
                                    />
                                </svg>
                            }
                            color={"secondary"}
                            variant={"outlined"}
                            disabled={cart.length === 0}
                            label={content.getValue("button_order")}
                        />
                    </Link>
                </Mobile>
            </PageWrapper>
        </>
    );
}

export interface IProjectsCart {}

export default ProjectsCart;
